module.exports = __webpack_public_path__ + "img/about_us_2.ebf4e17b.jpg";